import { Option, useFormContextRequired } from 'ui-builder';
import React, { useEffect } from 'react';
import { ProjectType } from 'nekst-api';
import { ProjectTypeDropdown } from '../../Projects';

export function SetupAreaConstrainedProjectTypeDropdown(props: {
  additionalOptions?: Option<string | null>[];
  resetValue?: ProjectType | null,
  source?: string;
  label?: string;
}) {
  const formContext = useFormContextRequired();

  const areaProjectType = formContext.data?._areaProjectType;

  const source = props.source || 'projectType';

  useEffect(() => {
    if (areaProjectType) {
      formContext.onChangeCallback({
        [source]: areaProjectType
      });
    } else if (props.resetValue !== undefined) {
      formContext.onChangeCallback({
        [source]: props.resetValue
      });
    }
  }, [areaProjectType]);

  return (
    <ProjectTypeDropdown
      label={props.label || 'Transaction Type'}
      source={source}
      isClearable={false}
      includedTypes={areaProjectType ? [areaProjectType] : undefined}
      isDisabled={!!areaProjectType}
      additionalOptions={props.additionalOptions}
    />
  );
}
